import { partnerConfig } from '@lib/helpers/partner';
import { useLauraLogo } from '@lib/hooks/features';
import { FC } from 'react';
import styled from 'styled-components';

interface Props {
  avatarUrl?: string | null;
  className?: string;
  alt?: string;
  size?: number;
}

const Wrapper = styled.img<{ size: number }>`
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  border-radius: 50%;
`;

const Avatar: FC<Props> = ({
  className,
  avatarUrl,
  alt = 'avatar',
  size = 60,
}) => (
  <Wrapper
    className={className}
    src={avatarUrl || 'https://image.flaticon.com/icons/svg/1738/1738691.svg'}
    alt={alt}
    size={size}
  />
);

export const LauraAvatar = ({ size, ...props }: Props) => {
  const laura = useLauraLogo();

  if (partnerConfig?.id && partnerConfig.colors) {
    const sizee = size || 60;
    return (
      <p
        style={{
          width: `${sizee}px`,
          height: `${sizee}px`,
          borderRadius: '50%',
          backgroundColor: partnerConfig.colors.buttonColor,
          color: partnerConfig.colors.buttonFontColor || '#fff',
          fontWeight: 'bold',
          textAlign: 'center',
          flexShrink: 0,
          position: 'relative',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          {partnerConfig.id[0].toUpperCase()}
        </span>
      </p>
    );
  }

  return <Avatar {...props} size={size} avatarUrl={laura} />;
};

export default Avatar;
